export default __webpack_public_path__ + "static/cloud_vulcano-742aa1ae35bd1c06d6fcf059c3a71e36.png";